import classNames from 'classnames';
import { FC } from 'react';
import styles from './DropdownDivider.module.css';

interface DropdownDividerProps {
  'className'?: string;
  'data-testid'?: string;
}

const DropdownDivider: FC<DropdownDividerProps> = ({ className, 'data-testid': testId }) => (
  <div className={classNames(styles.divider, className)} data-testid={testId} />
);

export default DropdownDivider;
